import React, {useState, useEffect, useMemo, useReducer} from "react"
import { useReactTable, getCoreRowModel, getPaginationRowModel, getSortedRowModel, flexRender } from "@tanstack/react-table"
import {  useQuery } from '@tanstack/react-query'
import { Icon } from "@fluentui/react";
import ReactTablePagination from './ReactTablePagination'
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';

import { t } from "i18next";

import { useTranslation } from "react-i18next";

// import customStyles from './modality.module.css';
// import UsersFilter  from "./UsersFilter"


var initialState = {
    queryPageIndex: 0,
    queryPageSize: 10,
    totalCount: 0,
    queryPageFilter:{"payload":{}},
    queryPageSortBy: [],
};

const PAGE_CHANGED = 'PAGE_CHANGED';
const PAGE_SIZE_CHANGED = 'PAGE_SIZE_CHANGED';
const PAGE_SORT_CHANGED = 'PAGE_SORT_CHANGED';
const PAGE_FILTER_CHANGED = 'PAGE_FILTER_CHANGED';
const TOTAL_COUNT_CHANGED = 'TOTAL_COUNT_CHANGED';

const reducer = (state, { type, payload }) => {
  switch (type) {
    case PAGE_CHANGED:
        return {
            ...state,
            queryPageIndex: payload,
        };
    case PAGE_SIZE_CHANGED:
        return {
            ...state,
            queryPageSize: payload,
        };
    case PAGE_SORT_CHANGED:
        return {
            ...state,
            queryPageSortBy: payload,
        };
    case PAGE_FILTER_CHANGED:
        return {
            ...state,
            queryPageFilter: {payload}
        };
    case TOTAL_COUNT_CHANGED:
        return {
            ...state,
            totalCount: payload,
        };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
};



const Sorting = ({ column }) => (
    <span className="react-table__column-header sortable">
      {column.isSortedDesc === undefined ? (
        // <SortIcon />
        <></>
      ) : (
        <span>
          {column.isSortedDesc
            ? <Icon  {...column.getHeaderProps(column.getSortByToggleProps())} iconName="SortUp" className="ms-fontSize-12"></Icon>
            : <Icon  {...column.getHeaderProps(column.getSortByToggleProps())} iconName="SortDown" className="ms-fontSize-12"></Icon>}
        </span>
      )}
    </span>
  );

const DataTable = (props) => {

    if(props.initialState != null || props.initialState != undefined){
       initialState.queryPageFilter.payload = props.initialState;
    }
    const [keyword, setKeyword] = useState('');
    const [useFilter, setUseFilter] = useState(false);

    const [t, i18n] = useTranslation();

    // Could be used in future
    const onClickFilterCallback = ( filter ) => {
        if(filter.trim() === "") {
            alert('Please enter a keyword to search!')
            return
        }
        if(filter === keyword)   {
            alert('No change in search')
            return
        }
        setUseFilter(true)
        setKeyword(filter)
    }

    const [{ queryPageIndex, queryPageSize, totalCount, queryPageFilter, queryPageSortBy }, dispatch] =
    useReducer(reducer, initialState);

    const { isLoading, error, data, isSuccess } = useQuery({
        queryKey: ["auditlog",queryPageIndex, queryPageSize, queryPageFilter, queryPageSortBy],
        queryFn: () => {
            // console.log(queryPageIndex+" "+queryPageSize);
            return props.fetchFunction(queryPageIndex, queryPageSize, queryPageFilter, queryPageSortBy)
        },
        keepPreviousData: true,
        staleTime: Infinity,
        gcTime: props.cacheTime==null||props.cacheTime==undefined?10000:props.cacheTime
    });

    const totalPageCount = Math.ceil(totalCount / queryPageSize)
    const columns = props.columns    
    const table = useReactTable({
        columns,
        data: data?.results || [],
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        getSortedRowModel: getSortedRowModel(),
        rowCount: data ? totalPageCount : 0,
        state: {
            pagination: {
                pageIndex: queryPageIndex,
                pageSize: queryPageSize
            }
        },
        manualPagination: true,
        manualSorting: true
    });
    
    const { pageIndex, pageSize } = table.getState().pagination;
    const pageOptions = table.getPageCount();
    const canPreviousPage = pageIndex > 0;
    const canNextPage = pageIndex < pageOptions - 1;
    const rows = table.getRowModel().rows;
    const manualPageSize = []
    
    useEffect(() => {
        dispatch({ type: PAGE_CHANGED, payload: pageIndex });
    }, [pageIndex]);

    useEffect(() => {
        dispatch({ type: PAGE_SIZE_CHANGED, payload: pageSize });
        gotoPage(0);
    }, [pageSize, gotoPage]);

    useEffect(() => {
        dispatch({ type: PAGE_SORT_CHANGED, payload: sortBy });
        //gotoPage(0);
    }, [sortBy, gotoPage]);

    

    useEffect(() => {
            dispatch({ type: PAGE_FILTER_CHANGED, payload: props.filterObj });
            gotoPage(0);
        
    }, [gotoPage,props.searchClicked]);

    useEffect(() => {
        if(props.onChangeFilter == null || props.onChangeFilter == undefined){
            dispatch({ type: PAGE_FILTER_CHANGED, payload: props.filterObj });
        }
       
    }, [props.filterObj]);

    useEffect(() => {
        dispatch({ type: PAGE_FILTER_CHANGED, payload: props.filterObj });
    
}, [gotoPage,props.updateCurrentPage]);

    useEffect(() => {
        dispatch({ type: PAGE_FILTER_CHANGED, payload: props.filterObj });
    }, [props.updateCurrentPage==null || props.updateCurrentPage==undefined?props.updateCurrentPage:null]);

    useEffect(() => {
        if (data?.count) {
            dispatch({
            type: TOTAL_COUNT_CHANGED,
            payload: data.count,
            });
        }
    }, [data?.count]);

    if (error) {
        return <p>Error</p>;
    }

    if (isLoading) {
        return <Spinner size={SpinnerSize.large}/>;
    }
    if(isSuccess)
    return (
            <>
                <div className='table react-table'>

                {/* <form className="form form--horizontal">
                        <div className="form__form-group">
                            <div className="col-md-9 col-lg-9">
                            <UsersFilter onClickFilterCallback={onClickFilterCallback} defaultKeyword={keyword} />
                            </div>
                        </div>
                    </form> */}

                    
                    {
                        <> 
                    <table  style={{width:'100%'}} {...getTableProps()}>
                        <thead>
                            {headerGroups.map((headerGroup,i) => {
                                const { key, ...restHeaderGroupProps } = headerGroup.getHeaderGroupProps();
                            return (<tr key={key} {...restHeaderGroupProps}>
                                {headerGroup.headers.map((column,j) => {
                                const { key, ...restColumn } = column.getHeaderProps();
                                return (<th key={key} {...column.getHeaderProps({
                                    className: column.className,
                                    style: column.headerStyle,
                                })} 
                                >
                                    {column.render("Header")}{" "}
                                    {column.sorting?column.isSorted ? <Sorting column={column} /> : 
                                          <Icon key={j} {...column.getHeaderProps(column.getSortByToggleProps())} iconName="Sort" className="ms-fontSize-12"></Icon>    :<></>                              
                                    }
                                
                                </th>)
                                
                                })}
                            </tr>)
                    })}
                        </thead>
                        
                         <tbody {...getTableBodyProps()}>
                            {rows.length > 0 && rows.map((row, i) => {
                            prepareRow(row);
                            return (
                            
                                <tr key={i} {...row.getRowProps()}>
                                {row.cells.map((cell,i) => {
                                    const {key, ...restCellProps} = cell.getCellProps();
                                    return <td  style={{wordBreak:'break-all'}} key={key} {...cell.getCellProps({className:cell.column.classChildName, style:cell.column.rowStyle})}>{cell.render("Cell")}</td>;
                                })}
                                </tr>
                            );
                            return <></>
                            })
                        }
                        </tbody>
                       
                        </table>
                        {
                        typeof data?.count === 'undefined' || data.count == 0 &&<p style={{textAlign:'center',paddingTop:'10px'}}>{t("table.no-result-found")}</p>
                    } 
                            </>
                   
                }
                </div>
                {(rows.length > 0) && (
                    <>
                        <ReactTablePagination
                            page={page}
                            gotoPage={gotoPage}
                            previousPage={previousPage}
                            nextPage={nextPage}
                            canPreviousPage={canPreviousPage}
                            canNextPage={canNextPage}
                            pageOptions={pageOptions}
                            pageSize={pageSize}
                            pageIndex={pageIndex}
                            pageCount={pageCount}
                            setPageSize={setPageSize}
                            manualPageSize={manualPageSize}
                            dataLength={totalCount}
                        />
                        {/* <div className="pagination justify-content-end mt-2">
                            <span>
                            Go to page:{' '}
                            <input
                                type="number"
                                value={pageIndex + 1}
                                onChange={(e) => {
                                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                gotoPage(page);
                                }}
                                style={{ width: '100px' }}
                            />
                            </span>{' '}
                        </div> */}
                    </>
                )}
            </>
    )
}

export default DataTable;